import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Checkbox, Grid, Table } from "semantic-ui-react";
import { CommonModal, CommonTable, InputText } from "../../../components";

import {
  useCreateRecipeSpecificGenericProcess,
  useGetRecipeSpecificGenericProcess
} from "../../../api/recipe-specific-generic-process";
import { useGetStaticRecipeProcessTypes } from "../../../api/static-data";
import CommonSplitContainer from "../../../components/commonSplitContainer/CommonSplitContainer";
import MainBottomMultipleButtonView from "../../../components/mainBottomButtonView/MainBottomMultipleButtonView";
import { GenericProcessCol } from "../../../config/tableColConstant";
import { successMessage } from "../../../helpers/ErrorHandler";

import "./genericProcess.scss";

const GenericProcessModel = ({ visibleModal, setVisibleModal, companyDetails }: any) => {
  const [searchProcess, setSearchProcess] = useState<any>("");
  const [checkedRecipeSpecificProcess, setCheckedRecipeSpecificProcess] = useState<any>([]);

  const { data: processData } = useGetRecipeSpecificGenericProcess(companyDetails?.tenantId);
  const { data: staticRecipeProcessType } = useGetStaticRecipeProcessTypes();

  const { mutate: createRecipeIngredient } = useCreateRecipeSpecificGenericProcess();

  useEffect(() => {
    setCheckedRecipeSpecificProcess(processData?.map((item: any) => item?.processId) || []);
  }, [processData]);

  const enableDisable = (item: any) => {
    setCheckedRecipeSpecificProcess((prev: any) => {
      const prevArray = Array.isArray(prev) ? prev : [];
      if (prevArray.includes(item.value)) {
        return prevArray.filter((val: any) => val !== item.value);
      } else {
        return [...prevArray, item.value];
      }
    });
  };

  const confirmRecipeProcess = () => {
    createRecipeIngredient(
      {
        processIds: checkedRecipeSpecificProcess,
        tenantId: companyDetails?.tenantId
      },
      {
        onSuccess: () => {
          setVisibleModal(false);
          successMessage("Recipe specific process add and remove successfully");
        }
      }
    );
  };

  const filterStaticData = useMemo(() => {
    const re = new RegExp(_.escapeRegExp(searchProcess), "i");
    let searchResult = _.filter(staticRecipeProcessType, (res: any) => {
      return re.test(res?.["text"]);
    });
    return searchResult.map((item: any) => {
      const matchingRecipe = processData?.find((recipe: any) => recipe.processId === item.value);
      return {
        ...item,
        createdAt: matchingRecipe?.createdAt
      };
    });
  }, [searchProcess, staticRecipeProcessType, processData]);

  const checkEnableRecipeIngredient = (item: any) => {
    return checkedRecipeSpecificProcess.includes(item.value);
  };

  const { register } = useForm();

  const loadTableData = () => {
    return filterStaticData?.map((item: any, index: any) => {
      return (
        <Table.Row className="tbleR" key={index}>
          <Table.Cell className="recipeCheckBox">
            <Checkbox
              checked={checkEnableRecipeIngredient(item)}
              className="recipeCheckBoxContent"
              onClick={() => enableDisable(item)}
            />
            {item?.text}
          </Table.Cell>
          <Table.Cell>
            {item?.createdAt ? (
              <>{new Date(item?.createdAt).toISOString().slice(0, 19).replace("T", " ")}</>
            ) : null}
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  return (
    <>
      <CommonModal
        modalOpenState={visibleModal}
        modalCloseState={() => {
          setVisibleModal(false);
        }}
        centered={true}
        title={`Add Generic Process for ${companyDetails?.name}`}
      >
        <CommonSplitContainer
          topChild={
            <Grid>
              <Grid.Column computer={8} tablet={16} mobile={16}>
                <InputText
                  register={register}
                  name={`processName`}
                  placeholder="Search"
                  defaultValues={searchProcess}
                  onChangeFunction={(e: any) => {
                    setSearchProcess(e.target.value);
                  }}
                />
              </Grid.Column>
              <Grid.Column computer={16} tablet={16} mobile={16} className="pt-0">
                <CommonTable tableHeaderData={GenericProcessCol} className="pesticideTable">
                  {loadTableData()}
                </CommonTable>
              </Grid.Column>
            </Grid>
          }
          bottomChild={
            <MainBottomMultipleButtonView
              leftButtons={[
                {
                  title: "Cancel",
                  onClick: () => setVisibleModal(false),
                  buttonOutLine: true
                }
              ]}
              rightButtons={[
                {
                  contentView: 16,
                  title: "Allow",
                  onClick: () => {
                    confirmRecipeProcess();
                  },
                  buttonView: true
                }
              ]}
            />
          }
        />
      </CommonModal>
    </>
  );
};

export default GenericProcessModel;
